"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = Modal;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _LoadingOverlay = _interopRequireDefault(require("../LoadingOverlay"));

var _IconBtnTooltip = _interopRequireDefault(require("../IconBtnTooltip"));

require("./Modal.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Modal(_ref) {
  var DialogActionsProps = _ref.DialogActionsProps,
      DialogContentProps = _ref.DialogContentProps,
      DialogProps = _ref.DialogProps,
      DialogTitleProps = _ref.DialogTitleProps,
      actionButtons = _ref.actionButtons,
      children = _ref.children,
      fullWidth = _ref.fullWidth,
      includeLeftCancelBtn = _ref.includeLeftCancelBtn,
      isLoading = _ref.isLoading,
      maxWidth = _ref.maxWidth,
      modal = _ref.modal,
      onCloseModal = _ref.onCloseModal,
      show = _ref.show,
      title = _ref.title;
  var disableModalClose = isLoading;

  var actionButtonsCompile = function actionButtonsCompile() {
    if (actionButtons.length > 0) {
      return /*#__PURE__*/_react["default"].createElement(_material.DialogActions, _extends({
        className: "Modal_buttonsContainer"
      }, DialogActionsProps), /*#__PURE__*/_react["default"].createElement("div", {
        className: "Modal_cancelButton"
      }, includeLeftCancelBtn && /*#__PURE__*/_react["default"].createElement(_material.Button, {
        color: "primary",
        disabled: disableModalClose,
        onClick: onCloseModal,
        variant: "text"
      }, "Cancel")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "Modal_actionsButtons"
      }, actionButtons.map(function (button, index) {
        var variant = index === actionButtons.length - 1 ? button.buttonType || 'contained' : button.buttonType || 'text'; // default first button to 'contained' variant

        var color = button.color || 'primary';
        disableModalClose = button.loading || disableModalClose; // once set to true, should stay true

        return /*#__PURE__*/_react["default"].createElement(_LoadingOverlay["default"], {
          show: button.loading || false,
          key: button.label
        }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
          color: color,
          disabled: button.disabled || button.loading,
          onClick: button.action,
          variant: variant,
          style: {
            marginLeft: '10px'
          },
          type: button.type || 'button'
        }, button.label));
      })));
    }

    return /*#__PURE__*/_react["default"].createElement(_material.DialogActions, DialogActionsProps, /*#__PURE__*/_react["default"].createElement(_material.Button, {
      onClick: onCloseModal,
      variant: "contained"
    }, "Close"));
  };

  var theme = (0, _styles.useTheme)();
  return /*#__PURE__*/_react["default"].createElement(_material.Dialog, _extends({
    open: show,
    maxWidth: maxWidth || 'sm',
    onClose: modal || disableModalClose ? function () {
      return null;
    } : onCloseModal,
    fullScreen: (0, _material.useMediaQuery)(theme.breakpoints.down('sm')),
    fullWidth: fullWidth,
    id: "dialog"
  }, DialogProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Modal_titleContainer"
  }, /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, _extends({}, DialogTitleProps, {
    style: _objectSpread({
      margin: 0,
      padding: '10px 0',
      fontWeight: 'bold',
      fontSize: (0, _material.useMediaQuery)(theme.breakpoints.down('sm')) ? 'medium' : 'x-large',
      width: '90%',
      overflowWrap: 'break-word'
    }, DialogTitleProps.style)
  }), title.toUpperCase()), /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
    buttonProps: {
      disabled: disableModalClose
    },
    icon: "close",
    onClick: onCloseModal
  })), /*#__PURE__*/_react["default"].createElement(_material.Divider, {
    style: {
      margin: '0 20px'
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, _extends({
    id: "dialogContent"
  }, DialogContentProps), children), actionButtonsCompile(DialogActionsProps));
}

Modal.propTypes = {
  show: _propTypes["default"].bool.isRequired,
  title: _propTypes["default"].string.isRequired,
  onCloseModal: _propTypes["default"].func.isRequired,
  maxWidth: _propTypes["default"].oneOf(['sm', 'md', 'lg', false]),
  fullWidth: _propTypes["default"].bool,
  actionButtons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    action: _propTypes["default"].func.isRequired,
    buttonType: _propTypes["default"].string,
    color: _propTypes["default"].string,
    disabled: _propTypes["default"].bool,
    label: _propTypes["default"].string.isRequired,
    loading: _propTypes["default"].bool,
    type: _propTypes["default"].string
  })),
  modal: _propTypes["default"].bool,
  includeLeftCancelBtn: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  DialogProps: _propTypes["default"].object,
  DialogTitleProps: _propTypes["default"].object,
  DialogContentProps: _propTypes["default"].object,
  DialogActionsProps: _propTypes["default"].object
};
Modal.defaultProps = {
  modal: true,
  actionButtons: [],
  includeLeftCancelBtn: false,
  isLoading: false,
  fullWidth: false,
  DialogTitleProps: {}
};
var _default = Modal;
exports["default"] = _default;